import React from 'react';
import { Clock } from 'lucide-react';
import { Badge, Card, EmptyState, PageHeader } from '../ui';

/* Placeholder page for nav-visible features not yet enabled for this partner. */
const ComingSoon = ({ title, description, icon }) => (
  <div>
    <PageHeader title={title} actions={<Badge tone="info" dot>Coming soon</Badge>} />
    <Card pad={false}>
      <EmptyState
        icon={icon || Clock}
        title="This feature is on its way"
        description={description}
      />
    </Card>
  </div>
);

export default ComingSoon;
